export default __webpack_public_path__ + "static/media/AuthImage.b0be573c.png";